module.exports = __webpack_public_path__ + "img/imagen_construccion.b1856dae.webp";